import SuperCritical from 'lib/supercritical';
import { UIThemeSetter } from './model';
import { PORTCALLBUILDID } from 'core/build';

export const UIThemeSetterView = SuperCritical(({ model }  : { model : UIThemeSetter }) => {
    // not a view in the traditional definition, as it's modifying elements outside of the React root
    const 
        // use PORTCALLBUILDID as a cache busting token
        file = `${model.CssFile()}?version=${PORTCALLBUILDID}`,
        classes = model.CssClasses(),
        style = document.getElementById("pc-stylesheet") as HTMLLinkElement | null;

    // we set attribute not style.href property b/c property may have been converted to an absolute url,
    // meaning it differs from file but not meaningfully.
    if (style && style.getAttribute('href') !== file) style.setAttribute('href', file);

    document.body.className = classes;

    return null;
});


// WEBPACK FOOTER //
// ./apps/portcall/uithemesetter/view.tsx